<div class="embedded-content">
  <div class="section-block object-block">
    <div class="pdf-viewer-holder">
      <div class="pdfViewerDiv">
        <div class="section-block object-block">
          <div rlResizeLeft="annotations_comments" class="content-wrapper" id="content-wrapper">
            <pdf-viewer
              class="embedded-content-holder"
              id="pdf-viewer"
              [src]="url"
              [render-text]="true"
              [(page)]="config.page"
              [rotation]="config.rotation"
              [zoom]="config.zoom"
              [fit-to-page]="config.fitToPage"
              [original-size]="config.originalSize"
              (after-load-complete)="afterLoadPDF($event)"
              (text-layer-rendered)="textLayerRendered($event)"
              style="position: absolute; top: 0; right: 0; bottom: 0; left: 0"></pdf-viewer>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
